import { throttle } from 'lodash';
import { Middleware, Store } from 'redux';
import { State } from '../state';

const reduxStateKey = 'redux';

export const parseLocalStorageState = (): Partial<State> => {
  const stateString = window.localStorage.getItem(reduxStateKey);
  if (stateString === null) return {};
  try {
    const parsed = JSON.parse(stateString);
    // Only hydrate auth token; legacy entries may contain corrupted user shapes.
    return parsed.token ? { token: parsed.token } : {};
  } catch (_err) {
    return {};
  }
};

const saveLocalStorageThrottle = throttle((store: Store<State>) => {
  const { token } = store.getState();
  if (!token) {
    window.localStorage.removeItem(reduxStateKey);
    return;
  }
  window.localStorage.setItem(reduxStateKey, JSON.stringify({ token }));
}, 500);

const saveLocalStorageMiddleware: Middleware = (store: Store<State>) => (next) => (action) => {
  setTimeout(() => {
    // save localStorage in background - do not block!
    saveLocalStorageThrottle(store);
  }, 0);
  return next(action);
};

export default saveLocalStorageMiddleware;
